import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="warning-message"
export default class extends Controller {
  
  close() {
    this.element.remove()
  }
  
}
